export default __webpack_public_path__ + "static/media/4048.b1b74843.png";